<script setup lang="ts">
import type { CarStatus } from '../internal/types.ts'
import { StatusTag } from '@taler/ui'
import { useI18n } from 'vue-i18n'

const props = defineProps<{ status: CarStatus }>()
const { t } = useI18n()
</script>

<template>
  <StatusTag :tone="props.status === 'ACTIVE' ? 'ok' : 'neutral'">
    {{ t(`garage.status.${props.status}`) }}
  </StatusTag>
</template>
